import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppContainerComponent } from './app-container.component';
import { LeftBarComponent } from './left-bar/left-bar.component';
import { NavButtonComponent } from './nav-button/nav-button.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { IconComponent } from './icon/icon.component';
import { DropdownCardComponent } from './popover-card/dropdown-card/dropdown-card.component';
import { PopoverCardHeaderComponent } from './popover-card/popover-card-header/popover-card-header.component';
import { PopupBackdropComponent } from './popover-card/popup-backdrop/popup-backdrop.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { KeyingSharedModule } from '@overtur-monorepo/keying-shared';

@NgModule({
  declarations: [
    AppContainerComponent,
    LeftBarComponent,
    NavButtonComponent,
    TopBarComponent,
    IconComponent,
    DropdownCardComponent,
    PopoverCardHeaderComponent,
    PopupBackdropComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatChipsModule,
    KeyingSharedModule,
  ],
  exports: [
    AppContainerComponent,
    LeftBarComponent,
    NavButtonComponent,
    TopBarComponent,
    IconComponent,
    DropdownCardComponent,
    PopoverCardHeaderComponent,
    PopupBackdropComponent,
  ],
})
export class AppContainerModule {}
